import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'urlParser'
})
export class UrlParserPipe implements PipeTransform {

  transform(urlPattern: string, ...dataObjects: any[]): string {
    // Pokud není pattern nebo jsme nedostali žádné objekty k nahrazení
    if (!urlPattern || dataObjects.length === 0) return urlPattern;

    return urlPattern.replace(/\{([^}]+)\}/g, (match, key) => {
      // Projdeme všechny předané objekty
      for (const obj of dataObjects) {
        if (obj && obj[key] !== undefined) {
          return obj[key];
        }
      }

      // Pokud klíč není v žádném z předaných objektů, vrátíme původní match
      return match; 
    });
  }
}
